// Module
var code = "<div class=\"layouts\"> <div ui-view=\"navbar\"></div> <div ui-view=\"content\" data-ng-class=\"{'domain-has-notice': showDeleteAllContentNotice || displayBanner}\"></div> </div> ";
// Exports
module.exports = code;